export const imageTypes = {
  Image: 'image',
  Background: 'background',
}
